(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('orderProCurement', {
        templateUrl: 'views/components/views/orderProCurement/orderProCurement.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'orderProCurementService', 'logisticService', 'ttGridFactory', 'rememberService', 'layoutService', 'translateService', 'modalProgressFactory', 'modalService', function ($stateParams, stateService, utilityService, orderProCurementService, logisticService, ttGridFactory, rememberService, layoutService, translateService, modalProgressFactory, modalService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;

            let variableNames = {
                businessco_no: '',
                date_fom: '',
                date_tom: '',
                dateselector_index: '',
                orderprocurement_function_id: '',
                searchtext: ''
            };

            vm.translations = {
                tt_orderprocurement_po_validate: '',
                tt_orderprocurement_purch_validate: '',
                tt_orderprocurement_po_create: '',
                tt_orderprocurement_purch_create: '',
                tt_orderprocurement_po_creating: '',
                tt_orderprocurement_purch_creating: '',
                tt_orderprocurement_order_create_error_title: '',
                tt_orderprocurement_order_create_error_message: '',
                close: ''
            };

            translateService.translateBatch(vm.translations).then(function (data) {
                angular.forEach(vm.translations, function (_, key) {
                    if (angular.isDefined(data[key])) {
                        vm.translations[key] = data[key];
                    }
                });
            });

            vm.onGridBoxResized = function () {
                vm.grid?.gridfunc?.resize();
                vm.gridComponents?.gridfunc?.resize();
            }

            vm.model = {
                tabletSize: layoutService.getMediaQueries().tablet,
                gridReady: false,
                gridComponentsReady: false,
                orderProcurementViewBoxes: {
                    //height: '25vh',
                    rememberId: 'orderprocurement.boxes',
                    boxes: [
                        { item_id: uuid(), item_name: 'orderprocurement', type: 'h', size: '50', depth: 0 },
                        { item_id: uuid(), item_name: 'componentsgrid', type: 'h', size: '50', depth: 0 },
                        { item_id: uuid(), item_name: 'filters', type: 'v', size: '25', depth: 1 },
                        { item_id: uuid(), item_name: 'orderprocurementgrid', type: 'v', size: '75', depth: 1 }
                    ],
                },
                searchTextButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('searchtext') },
                    { id: 'search', icon: 'glyphicon glyphicon-search', color: 'success', type: 'success', onClick: () => vm.searchItems() }
                ],
                setting: {},
                selectListCompanies: [],
                selectListProcurementIds: [],
                orderCreateButtonText: vm.translations.tt_orderprocurement_po_create
            };

            vm.grid = new ttGridFactory({
                rememberId: 'w_orderprocurement_orderhead_grid',
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setOptionFunc((data) => optionFunc(data.data));

            let optionFunc = function (data) {
                if (data?.func && (data.func === 'CheckboxBoxClick' || data.func === 'CheckboxHeaderClick')) {
                    if (data.key === 'is_selected') {
                        loadGridComponents();
                    }
                }
            };

            vm.gridComponents = new ttGridFactory({
                rememberId: 'tt_orderprocurement_component_grid',
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setToolbar({
                buttons: [
                    {
                        name: 'create_order',
                        text: '',
                        func: function (data) { vm.createOrder() }, // vm.dynamicGrid.gridfunc.getIsSelectedRows
                        icon: 'none', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                        translate: true
                        //disabled: function () {
                        //    return vm.model.orderhead.setting_enable_oh_cancel !== '1' ? 'hidden' : vm.model.lockedCancel ? true : vm.canCancelRows() ? false : true;
                        //}
                    },
                    {
                        name: 'validate_order',
                        text: '',
                        func: function (data) { vm.createOrder(true) }, // vm.dynamicGrid.gridfunc.getIsSelectedRows
                        icon: 'none', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                        translate: true
                        //disabled: function () {
                        //    return vm.model.orderhead.setting_enable_oh_cancel !== '1' ? 'hidden' : vm.model.lockedCancel ? true : vm.canCancelRows() ? false : true;
                        //}
                    }
                ]
            });;

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await orderProCurementService.getSetting({
                    argtype: argType,
                    argvalue: argValue
                }))[0];

                loadProcurementTypeList();
                loadGrid();
            }

            async function loadProcurementTypeList() {
                vm.model.selectListProcurementIds = (await orderProCurementService.getProcurementTypeList());
            }

            async function loadCompanies() {
                vm.model.selectListCompanies = (await logisticService.listCompanies());
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                vm.grid.dataTask.loadData = {
                    method: 3588,
                    parameters: vm.model.setting
                };

                vm.model.gridReady = true;

                await vm.grid?.gridfunc?.read?.();
                loadGridComponents();
            }

            async function loadGridComponents() {
                vm.gridComponents.dataTask.loadData = {
                    method: 3590,
                    parameters: { ...vm.model.setting, is_selected: vm.grid?.gridfunc?.getIsSelectedRows?.() ?? [] },
                    dynamic: true
                };

                vm.model.gridComponentsReady = true;

                vm.gridComponents.config.toolbar.buttons[0].text = vm.model.setting.orderprocurement_function_id === 'po_create' ? vm.translations.tt_orderprocurement_po_create : vm.translations.tt_orderprocurement_purch_create;
                vm.gridComponents.config.toolbar.buttons[1].text = vm.model.setting.orderprocurement_function_id === 'po_create' ? vm.translations.tt_orderprocurement_po_validate : vm.translations.tt_orderprocurement_purch_validate;

                vm.gridComponents?.gridfunc?.rebind?.(true);
            }

            vm.createOrder = async function (validation_only) {
                const rows = vm.gridComponents?.gridfunc?.getIsSelectedRows?.() ?? [];

                if (!rows.length) return;

                let progress = modalProgressFactory.$create({
                    label: vm.model.setting.orderprocurement_function_id === 'po_create' ? vm.translations.tt_orderprocurement_po_creating : vm.translations.tt_orderprocurement_purch_creating,
                    min: 0,
                    max: rows.length
                });

                progress.show();
                
                for (const row of rows) {
                    progress.model.plabel = row.prod_id;
                    const result = await orderProCurementService.createOrder({ ...vm.model.setting, row, validation_only: validation_only ? 1 : 0 });

                    if (result[0].po_keyno > 0) {
                        row.po_keyno = result[0].po_keyno;
                    }

                    if (result[0].purch_internal_no > 0) {
                        row.purch_internal_no = result[0].purch_internal_no;
                    }
                    
                    row.errorcode = result[0].errorcode;
                    row.errormessage = result[0].errormessage;

                    vm.gridComponents?.gridfunc?.updateRow(row);

                    if (progress) {
                        if (progress?.instance?.closed?.$$state?.status && progress.instance.closed.$$state.status === 1) {
                            return '';
                        } else {
                            progress.step();
                        }
                    }
                }
                progress.hide();

                const errors = rows.filter(row => row.errorcode !== '0');
                if (errors.length > 0) {
                    console.dir(errors);
                    modalService.show({
                        type: 'warning',
                        title: vm.translations.tt_orderprocurement_order_create_error_title,
                        message: vm.translations.tt_orderprocurement_order_create_error_message,
                        buttons: [{
                            label: vm.translations.close,
                            cssClass: 'btn-warning',
                            action: function (dialogItself) {
                                dialogItself.close();
                            }
                        }]
                    });
                }
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                        case '':
                            break;
                        default:
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'businessco_no':
                    case 'date_fom':
                    case 'date_tom':
                    case 'dateselector_index':
                    case 'orderprocurement_function_id':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    case 'searchtext':
                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region RESET BUTTON FUNCTION

            function reset(id) {
                switch (id) {
                    case 'searchtext':
                        vm.model.setting.searchtext = '';

                        if (vm.model.setting.searchtext === '') {
                            rememberFunc('searchtext');
                            loadGrid();
                        }
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region SEARCH SUBMIT FUNCTION

            vm.searchItems = function () {
                rememberFunc('searchtext');
                loadGrid();
            };

            // #endregion SEARCH SUBMIT FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'businessco_no':
                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

                        vm.model.setting.businessco_no = value;

                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

                        rememberFunc('businessco_no');
                        loadGrid();
                        break;
                    case 'searchtext':
                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

                        vm.model.setting.searchtext = value;

                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

                        if (vm.model.setting.searchtext === '') {
                            rememberFunc('searchtext');
                            loadGrid();
                        }
                        break;
                    case 'orderprocurement_function_id':
                        if (utilityService.validateWatchValue(value, vm.model.setting.orderprocurement_function_id) !== true) return;

                        vm.model.setting.orderprocurement_function_id = value;

                        if (utilityService.validateParmsValue(vm.model.setting.orderprocurement_function_id) !== true) return;

                        rememberFunc('orderprocurement_function_id')
                        loadGridComponents();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region FIELD DATE RANGE CHANGE FUNCTION

            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
                vm.model.setting.date_fom = startDate;
                vm.model.setting.date_tom = endDate;
                vm.model.setting.dateselector_index = +dateInterval <= 0 ? vm.model.setting.dateselector_index : dateInterval;

                if (vm.model.setting.date_fom) rememberFunc('date_fom');
                if (vm.model.setting.date_tom) rememberFunc('date_tom');
                if (vm.model.setting.dateselector_index) rememberFunc('dateselector_index');

                if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) {
                    vm.model.setting.date_fomtom = vm.model.setting.date_fom + vm.model.setting.date_tom;
                    loadGrid();
                }
            };

            // #endregion FIELD DATE RANGE CHANGE FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
            	loadSetting();
                loadCompanies();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
